import lodash from "lodash";
import { createColumnInput, createColumnSelect } from "../../../../../components/table/c-table.logic";
import i18n from "../../../../../i18n";
import store from "../../../../../store";
import { conditionFormChecker, copyForm, putField } from "../../../../../utils/form";
import { callRequestStatus, callRequestType } from "../../../storage-location/request/request.section";
import {
    createFieldInput,
    createFieldSelect,
    createFieldTextArea
} from "../../../../../components/input/template-builder/template-builder.logic";
import { Modal } from "ant-design-vue";
import router from "../../../../../router";
import { defineAsyncComponent } from "vue";

const CIcon = defineAsyncComponent(() => import("../../../../../components/icon/CIcon"));

export const callUserObjective = ({ searchQuery }) => store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "USER_OBJECTIVE", value: searchQuery }).then(items => items.filter(item => ["1", "2"].includes(item.key)));
export const callDepartment = ({ searchQuery }) => store.dispatch("resource/v1/master/department/cacheFindAll", { searchQuery });
export const callRequestDoc = ({ searchQuery }) => store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "REQUEST_DOC", value: searchQuery });

export const callSendSampling = ({ approveCode, informApproveCode, userInfo }) => {
    const where = [
        { name: "isActive", type: "Boolean", operator: "=", value: true },
        { name: "isTemp", type: "Boolean", operator: "=", value: false },
        { name: "refStatus.key", type: "String", operator: "=", value: "complete" },
        { name: "refDepartment.id", type: "UUID", operator: "=", value: userInfo.refDepartment?.id },
    ];
    // where.push({ openBucket: true, name: "refSamplingAnalysis.id", type: "UUID", operator: "=", value: null });
    // where.push({ closeBucket: true, logic: "OR", name: "refSamplingAnalysis.refLastRequestTemp.refStatus.key", type: "String", operator: "in", value: ['draft', 'cancel', 'notApprove'] });
    if (informApproveCode) {
        where.push({ name: "refRelease.refInspection.refInformTemp.approveCode", type: "String", operator: "like", value: informApproveCode });
    } else if (approveCode) {
        where.push({ name: "approveCode", type: "String", operator: "like", value: approveCode });
    }
    return store
        .dispatch("resource/v1/transaction/sendSampling/search", {
            criteria: {
                isDistinct: true,
                select: ["id", "approveCode", "refUserCompany.id", "refUserCompany.fullNameTh",
                    "refRelease.id",
                    "refRelease.approveCode",
                    "refRelease.refInspection.id",
                    "refRelease.refInspection.approveCode",
                    "refRelease.refInspection.refInformTemp.id",
                    "refRelease.refInspection.refInformTemp.approveCode",
                ],
                page: 0,
                size: 1000000,
                where,
                sort: [{ name: "approveCode", type: "DESC" }]
            }
        })
        .then(page => page.data);
};

export const callSendSamplingFull = ({ id }) => {
    const criteria = {
        select: [
            "**",
            `refUserCompany.**`,
            `refUser.**`,
            `refDepartment.*`,
        ],
        page: 0,
        size: 1,
        where: [{ name: "id", type: "UUID", operator: "=", value: id }],
        children: [
            {
                name: "products",
                select: ["**",
                    "refSampling.refReleaseProduct.refRelease.refInspection.approveCode",
                    "refSampling.refReleaseProduct.refInspectionProduct.refInformProduct.refHazObject.nameTh",
                    "refSampling.refReleaseProduct.refInspectionProduct.refInformProduct.refHaz.tradeNameTh",
                    "refSampling.refReleaseProduct.refInspectionProduct.refInformProduct.refHaz.refSubStanceTypeMain.value",
                    "refSampling.refSizeUnit.value",
                    "refSampling.refQtyUnit.value",
                ],
                page: 0,
                size: 1000000,
                sort: [{ name: "createDate", type: "ASC" }]
            }
        ]
    };
    return store.dispatch("resource/v1/transaction/sendSampling/search", { criteria, })
        .then(page => page.data[0])
};

export const createColumns = () => {
    const columns = [
        createColumnSelect({
            title: () => i18n.global.t("model.request.refRequestType"),
            dataIndex: "refRequestType.value",
            customRender: ({ record }) => <div>
                <span>{record.refRequestType?.value}</span>
                {record.isSignCa ? <CIcon class="ml-1" file="sign.svg"></CIcon> : null}
            </div>,
            inputProp: () => ({ list: callRequestType, optLabel: "value" }),
            search: { name: "refRequestType.id" },
            align: "center",
        }),
        createColumnInput({ title: () => i18n.global.t("model.request.draftCode"), dataIndex: "draftCode", align: "center" }),
        createColumnInput({ title: () => i18n.global.t("model.request.requestCode"), dataIndex: "requestCode", align: "center" }),
        createColumnInput({
            title: () => i18n.global.t("views.request.approveCode"),
            dataIndex: "refSendSampling.approveCode",
            align: "center"
        }),
        createColumnInput({
            title: () => i18n.global.t("model.sendSampling.products"),
            dataIndex: "refSendSamplingTemp.products",
            align: "center",
            customRender: ({ record }) => {
                const labels = record.refSendSamplingTemp?.products?.map(d => {
                    return <div>{ d.refSampling?.approveCode }</div>
                }) || [];
                return <>{...labels}</>
            }
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.sendSampling.refDepartment"),
            dataIndex: "refDepartment.nameTh",
            inputProp: () => ({ list: callDepartment, optLabel: "nameTh" }),
            search: { name: "refDepartment.id" },
            align: "center",
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.request.refStatus"),
            dataIndex: "refStatus.value",
            inputProp: () => ({
                list: ({searchQuery}) => callRequestStatus({ searchQuery }),
                optLabel: "value"
            }),
            search: { name: "refStatus.id" },
            align: "center"
        })
    ];
    return columns;
};

export const createField = ({ props, data, key }) => {
    const fields = [
        ...createFieldRequest({ props, data, key }),
    ];
    return fields;
};

export const createFieldRequest = ({ props, data, key }) => {
    const { viewOnly, requestTypeKeys } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refRequestType`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.request.refRequestType"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refRequestType,
                            "onUpdate:value": value => {
                                model.refRequestType = value;
                            },
                            disabled: viewOnly,
                            list: ({ searchQuery }) => callRequestType({ searchQuery }).then(d=>d.filter(d2 => requestTypeKeys?.includes(d2?.key))),
                            optLabel: "value",
                            allowClear: false
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}requestCode`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.request.requestCode"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.requestCode,
                            disabled: true
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refSendSamplingTemp.approveCode`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.request.approveCode"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refSendSamplingTemp?.approveCode,
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refSendSampling`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.sendSampling.referDoc"),
                inputProp: ({ field }) => {
                    return lodash.merge(
                        {
                            value: model.refSendSampling,
                            "onUpdate:value": value => {
                                const oldValue = model.refSendSampling;
                                model.refSendSampling = value;
                                if (oldValue) {
                                    Modal.confirm({
                                        title: i18n.global.t("views.request.modal.change", {
                                            text: i18n.global.t("model.storageLocation.approveCode")
                                        }),
                                        autoFocusButton: "cancel",
                                        onOk: () => cloneSendSampling({ props, model, id: value?.id }),
                                        onCancel: () => {
                                            model.refSendSampling = oldValue;
                                        }
                                    });
                                } else {
                                    cloneSendSampling({ props, model, id: value?.id });
                                }
                            },
                            disabled: viewOnly,
                            list: ({ searchQuery }) => callSendSampling({ approveCode: searchQuery, userInfo: store.state.resource.auth.info?.user }),
                            renderLabel: ({ item }) => (
                                <div>
                                    {item.approveCode}
                                </div>
                            ),
                            allowClear: false
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    );
                },
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldTextArea({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}lastStatus.forRequestRemark.0.remark`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("views.request.sendSamplingInfo.descToApprove"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.lastStatus.forRequestRemark?.[0]?.remark,
                            "onUpdate:value": value => {model.lastStatus.forRequestRemark[0].remark = value},
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldTextArea({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}lastStatus.forApproveRemark.0.remark`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("views.request.sendSamplingInfo.descToRequest"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.lastStatus.forApproveRemark?.[0]?.remark,
                            "onUpdate:value": value => (model.lastStatus.forApproveRemark[0].remark = value),
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
        ]
    });
};

export const cloneSendSampling = ({ props, model, id }) => {
    if (id) {
        callSendSamplingFull({ props, id }).then(sendSampling => {
            const refSendSamplingTemp = copyForm({ form: { ...sendSampling, approveCode: null, isTemp: true } });
            if (id) {
                refSendSamplingTemp?.attachments?.forEach((d, index) => (d.refRealId = sendSampling.attachments[index].id));
                refSendSamplingTemp?.products?.forEach((d, index) => {
                    d.refReal = { id: sendSampling.products[index].id }
                    d.refSendSampling = null;
                });
            }
            router.push({
                name: router.currentRoute.value.name,
                params: { props: JSON.stringify({ form: { ...model, refDepartment: sendSampling?.refDepartment, refSendSamplingTemp } }) },
                query: { _timestamp: new Date().getTime() }
            });
        });
    } else {
        router.push({
            name: router.currentRoute.value.name,
            params: { props: JSON.stringify({ forceDefault: true, form: model }) },
            query: { _timestamp: new Date().getTime() }
        });
    }
};